import { createSceneReducer } from '../../reducers-util';
import usersDataReducer from './users.data';
import usersUiReducer from './users.ui';

export default createSceneReducer(usersDataReducer, usersUiReducer);
